import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { BaseComponent } from "app/base/base.component";
import { NotifMessageService } from "app/core/services/notifmessage.service";
import { AuthenticatedRouteGuard } from "security/authenticatedRouteGuard.service";
import { MerchantSciService } from "app/core/services/merchant.sci.service";
import { MerchantSciId } from "app/core/models/merchantSciId";

@Component({
  selector: "app-merchant-sci",
  templateUrl: "./merchant-sci.component.html",
})
export class MerchantSciComponent extends BaseComponent implements OnInit {
  @Input() merchantId: number;
  @Input() isEditMode: boolean;
  @Input() isDetailsMode: boolean;

  sci: MerchantSciId;

  sciList: Array<String> = new Array<String>();

  isCreatingNewTable: boolean = false;

  sciForm: FormGroup;

  lastTerm: String;

  sciControl: FormControl = new FormControl();

  pager = {
    page: 0,
    size: 20,
    sort: "externalRef,ASC",
  };

  constructor(
    private sciService: MerchantSciService,
    private roleGuard: AuthenticatedRouteGuard,
    private notifService: NotifMessageService,
    private formBuilder: FormBuilder,
    public router: Router,
  ) { super(router); }

  ngOnInit(): void {
    if (this.isEditMode) {
      this.initForm();
    }
    this.getSciList(this.merchantId);
    if (this.roleGuard.isEnabled("SEPA_SCI_READ") && this.roleGuard.isEnabled("SEPA_SCI_EDIT") && this.merchantId !== undefined) {
      this.getSciList(this.merchantId);
    }
  }
  get sciCurrentEntry() {
    return this.sciForm.controls;
  }


  initForm(): void {
    this.sciForm = this.formBuilder.group({
      sci: new FormControl('', Validators.required)
    });
  }

  getSciList(merchantId) {
    this.sciService.getSciListByMerchantId(merchantId).subscribe((scis) => {
      this.sciList = scis;
      if (this.isEditMode && this.sciList.length == 0) {
        this.isCreatingNewTable = true;
        this.sciForm.get("tableName").setValue("DEFAULT_TABLE");
        this.sciForm.disable();
        this.sciForm.updateValueAndValidity();
        return;
      } else if (this.isEditMode) {
        this.sciForm.enable();
        this.sciForm.updateValueAndValidity();
      } else if (this.sciList.length == 0) {
        return;
      }

      this.isCreatingNewTable = false;
    });
  }

  addSci() {
    let newSci: MerchantSciId = new MerchantSciId();
    newSci = new MerchantSciId();
    newSci.sci = this.sciForm.get("sci").value;
    newSci.merchantId = this.merchantId;

    this.sciService
      .createSci(newSci)
      .subscribe((res) => {
        if (res != null) {
          this.sciForm.reset();
          this.notifService.notifySuccess("SEPA_SCI_CREATED");
        }
        this.getSciList(this.merchantId);
      });
  }

  removeSci(sci: string) {
    const sciToDelete = new MerchantSciId();
    sciToDelete.sci = sci;
    sciToDelete.merchantId = this.merchantId;
    const index = this.sciList.findIndex(
      (entry) => entry == sci
    );
    this.sciList.splice(index, 1);
    this.sciService
      .deleteSci(sciToDelete)
      .subscribe((res) => {
        if (res != null) {
          this.notifService.notifySuccess("SEPA_SCI_DELETED");
        }
        this.getSciList(this.merchantId);
      });
  }

}
